import { FileUploaderConfig, ProgressData, S3AnonymousFileUploader, UploadCompletedData, UploadErrorData, UploadEvent, UploadEventData, UploadEventListener, UploadListeners } from "./common/S3AnonymousFileUploader";
import prettyBytes from "pretty-bytes";
import { validateFormData } from "./common/FormValidators";
import axios from "axios";


if(window['fbq']) {
    console.log("Pushing view content fb tracker");
    window['fbq']('track', 'ViewContent');
}
//const FORM_POST_URL = "https://ccform.ciaopeople.it/subscriptions";
const FORM_POST_URL = "https://kfbbtcnomg.execute-api.eu-central-1.amazonaws.com/subscriptions";

const awsConfig: FileUploaderConfig = {
    region: "eu-west-1",
    identityPoolId: 'eu-west-1:4d38e87d-de4e-4033-bec4-857b2c7b29d1',
    bucketPath: "creator-challenge",
    bucketId: "ciaopeople-public-uploads"
};

const uploader = new S3AnonymousFileUploader(awsConfig);

const fileUploadForms = document.querySelectorAll("input[type=\"file\"]");
fileUploadForms.forEach((el) => {
    const input = el as HTMLInputElement;
    input.addEventListener("change", (evt) => {
        const tgt = input.dataset["target"] ? document.getElementById(input.dataset["target"]) as HTMLInputElement : null;
        if (tgt && input.files && input.files.length > 0) tgt.value = input.files[0].name;
    })

})


function createListener(resolver: (e: UploadEvent) => void, reject: (a: any) => void, inputEl: HTMLInputElement): UploadListeners {

    const progressEl = inputEl.dataset.progressBar ? document.getElementById(inputEl.dataset.progressBar) : null;
    return {
        started: (evt: UploadEvent) => {
            console.log("Upload Started", evt.filename);
            if (progressEl) progressEl.innerText = "Caricamento iniziato";
        },
        completed: (evt: UploadEvent) => {
            console.log("Upload Completed", evt);
            const compTime = evt.data && (evt.data as UploadCompletedData).uploadTime ? (evt.data as UploadCompletedData).uploadTime : 0;
            if (progressEl) progressEl.innerText = "Caricato correttamente in " + (compTime / 1000) + " secondi";
            resolver(evt);
        },
        error: (evt: UploadEvent) => {
            console.log("Upload Error", evt);
            if (progressEl) progressEl.innerText = "Caricamento fallito (err: " + (evt.data && (evt.data as UploadErrorData) ? (evt.data as UploadErrorData).requestId : "");
            reject(evt) + ")";
        },
        progress: (evt: ProgressData) => {
            console.log("Upload Progress", evt);
            if (progressEl) {
                progressEl.innerText = "Caricamento in corso: " + evt.percentage + "% " +
                    prettyBytes(evt.uploaded, { locale: true }) + " / " + prettyBytes(evt.total, { locale: true })
                progressEl.parentElement.style.display = "block";
                progressEl.style.width = evt.percentage + "%";
            }
        }
    }

}

function handleUploads(subpath: string): Promise<UploadEvent[]> {

    const fuArray: HTMLInputElement[] = [];
    fileUploadForms.forEach(x => {
        const input = x as HTMLInputElement
        fuArray.push(input);
    })

    const promArray: Promise<UploadEvent>[] = fuArray.map((el) => {
        if (el.files && el.files.length > 0) {
            const prefixName = el.dataset["name-prefix"] ? el.dataset["name-prefix"] : el.id;
            const nameTrans = (name: string, ext: string) => {
                return (subpath ? subpath + "/" : "") + prefixName + "-" + (new Date().getTime()) + (ext ? "." + ext : "")
            }
            return new Promise((resolve, reject) => {
                const listener = createListener(resolve, reject, el);
                uploader.upload(el.files, listener, nameTrans);
            });
        }
        return Promise.resolve(null);
    });

    return Promise.all(promArray);
}


function displayErrors(errors: string[]): void {
    let errorsContainer = document.querySelector("#errors");
    if (errorsContainer) errorsContainer.innerHTML = '';
    errors.forEach((err) => {
        errorsContainer.innerHTML += `<li>${err}</li>`
    })
}

function redirectToConfirm(): void {
    document.querySelector("form").remove();
    document.getElementById("modal").style.display = "block";
}


function showLoader() {
    const submitButton = document.querySelector("button[type=\"submit\"]") as HTMLButtonElement;
    //submitButton.style.fontSize = "0";
    submitButton.childNodes.forEach((node) => {
        if(node.nodeType == Node.TEXT_NODE) {
            node.textContent = "";
        }
    });
    document.getElementById("submit-loader").style.display = "inline-block";

}

function hideLoader() {
    console.log("here");
    const submitButton = document.querySelector("button[type=\"submit\"]") as HTMLButtonElement;
    //submitButton.style.fontSize = "0";
    let putOnce = false;
    submitButton.childNodes.forEach((node) => {
        if(!putOnce && node.nodeType == Node.TEXT_NODE) {
            node.textContent = "INVIA";
            putOnce = true;
        }
    });
    document.getElementById("submit-loader").style.display = "none";
}

function gtag_report_conversion() {
    window['gtag']('event', 'conversion', { 'send_to': 'AW-964377498/QtGcCM3ns4oYEJr37MsD' });
} 

function statsMark(label: string) {
    if(window['ga']) window["ga"]('send', 'event', 'creator-challenge', 'submit', label);
    if(label == "ok") {
        if(window['fbq']) {
            console.log("Pushing submit application fb tracker");
            window['fbq']('track', 'SubmitApplication');
        }
    }
}

function handleSubmit(evt: SubmitEvent): boolean {
    const submitButton = document.querySelector("button[type=\"submit\"]") as HTMLButtonElement;
    if (submitButton) submitButton.disabled = true;
    console.log(evt);
    evt.preventDefault();
    const formData = new FormData(evt.target as HTMLFormElement);
    const formJson: any = {};
    formData.forEach((v, k) => formJson[k] = v)

    const errors = validateFormData(formJson);
    statsMark("click");
    if (errors.length <= 0) {
        //cambia cta invia con loader
        showLoader();
        //svuota errori
        displayErrors(errors);
        console.log("Going for uploads");
        handleUploads(formJson.email).then(res => {
            formJson.uploadedFiles = res && res ? res.filter(x => x && x.data).
                map(x => (x.data as UploadEventData).s3FilePath) : [];
            console.log("Ready to submit FormData", formJson);
            delete formJson["cv-upload-input"];
            delete formJson["video-upload-input"];
            return axios.post(FORM_POST_URL, JSON.stringify(formJson), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((axres) => {
                if (axres.status >= 200 && axres.status < 300) {
                    statsMark("ok");
                    gtag_report_conversion();
                    redirectToConfirm();
                    return true;
                }
                else {
                    statsMark("srverror");
                    return Promise.reject("There was an error on form submit");
                }
            })
        }).catch((err) => {
            console.log("error", err);
            errors.push("Impossibile completare la richiesta");
            displayErrors(errors);
            return Promise.reject(err);
        }).finally(() => {
            hideLoader();
            if (submitButton) submitButton.disabled = false;
        });
    }
    else {
        if (submitButton) submitButton.disabled = false;
        displayErrors(errors);
        statsMark("errors");
    }
    return false;

}

const submitButton = document.querySelector("form") as HTMLFormElement;
console.log("form submit", submitButton);
submitButton.onsubmit = handleSubmit;

window["handleSubmit"] = handleSubmit;